<div class="d-flex flex-column">
  <th-header></th-header>
  <div class="d-flex flex-column w-100">
    <div class="d-flex">
      <th-side-nav></th-side-nav>
      <div
        class="main-container container-fluid"
        [class.authenticated]="authService.isAuthenticated()"
        [class.nav-collapsed]="sideNavService.navCollapsed | async"
        #scrollContainer
      >
        <main>
          @if (authService.isAuthenticated()) {
            <th-out-of-office-banner></th-out-of-office-banner>
          }
          <div class="main-container-content">
            <router-outlet></router-outlet>

            <th-footer></th-footer>
          </div>
        </main>
      </div>
    </div>
  </div>
</div>

@if (lazyLoading) {
  <div class="progress-linear" role="progressbar">
    <div class="container">
      <div class="bar"></div>
    </div>
  </div>
}

<ng-template thGlobalModal>
  <th-global-modal></th-global-modal>
</ng-template>

<th-loading-indicator></th-loading-indicator>
